import React, { useState, useEffect } from "react";

const AddTestimonialModal = ({ isOpen, onClose, onSubmit, editData }) => {
  // Form state
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    position: "",
    comment: "",
    status: "",
  });

  // Error state
  const [errors, setErrors] = useState({
    name: "",
    position: "",
    comment: "",
  });

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      if (editData) {
        setFormData({
          id: editData?.id || editData?.name || Math.random().toString(36).substr(2, 9),
          name: editData?.name || "",
          position: editData?.designation || "",
          comment: editData?.description || "",
          status: editData?.status || "",
        });
      } else {
        setFormData({ 
          id: Math.random().toString(36).substr(2, 9), 
          name: "", 
          position: "", 
          comment: "", 
          status: "" 
        });
      }
      setErrors({ name: "", position: "", comment: "" });
    }
  }, [isOpen, editData]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  // Form validation
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }

    if (!formData.position.trim()) {
      newErrors.position = "Position/Company Name is required";
      isValid = false;
    }

    if (!formData.comment.trim()) {
      newErrors.comment = "Comment is required";
      isValid = false;
    } else if (formData.comment.length > 500) {
      newErrors.comment = "Comment cannot exceed 500 characters";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validateForm()) {
      onSubmit?.(formData);
      onClose();
    }
  };

  // useEffect(() => {
  //   if (editData) {
  //     setFormData({
  //       name: editData ? editData?.name : "",
  //       position: editData ? editData?.designation : "",
  //       comment: editData ? editData?.description : "",
  //       status: editData ? editData?.status : "",
  //     });
  //   }
  // }, [editData]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-400 hover:text-gray-500"
          >
            {/* <X className="h-5 w-5" /> */}
          </button>

          <h2 className="text-xl font-medium mb-6">
            {editData ? "Edit Testimonial" : "Add Testimonial"}
          </h2>

          <div className="space-y-4">
            {/* Name Field */}
            <div>
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="type here"
                className={`w-full p-2 border rounded-md ${
                  errors.name ? "border-red-500" : ""
                }`}
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>
              )}
            </div>

            {/* Position/Company Field */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Position/Company Name
              </label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleInputChange}
                placeholder="type here"
                className={`w-full p-2 border rounded-md ${
                  errors.position ? "border-red-500" : ""
                }`}
              />
              {errors.position && (
                <p className="text-red-500 text-sm mt-1">{errors.position}</p>
              )}
            </div>

            {/* Comment Field */}
            <div>
              <label className="block text-sm font-medium mb-1">Comment</label>
              <textarea
                name="comment"
                value={formData.comment}
                onChange={handleInputChange}
                placeholder="Type your reason here"
                className={`w-full p-2 border rounded-md min-h-[100px] resize-none ${
                  errors.comment ? "border-red-500" : ""
                }`}
              />
              <div className="flex justify-between text-sm">
                {errors.comment && (
                  <p className="text-red-500">{errors.comment}</p>
                )}
                <span
                  className={`text-right ${
                    formData.comment.length > 500
                      ? "text-red-500"
                      : "text-gray-500"
                  }`}
                >
                  {formData.comment.length}/500
                </span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-2 px-4 border rounded-md text-blue-600 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="flex-1 py-2 px-4 rounded-md bg-blue-600 text-white hover:bg-blue-700"
            >
              {editData ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTestimonialModal;
